<div class="nav-tig">
    <div class="logo-tig">
        <a [routerLink]="['/index']" routerLinkActive="active"><img id="logo-width" src="/assets/images/onon-logo-font_w.png" alt="Onon字体 - logo"></a>
    </div>
    <div class="link-tig">
        <div class="nav-btn">
            <input type="button" id="nav-btn" (click)="navbtn()">
            <span id="nbs1"></span>
            <span id="nbs2"></span>
        </div>
        <div class="menu" id="menu">
            <ul>
                <li>
                    <a [routerLink]="['/index']" routerLinkActive="active" (click)="backToTop()" (click)="navbtnR()">首页</a>
                </li>
                <li>
                    <a [routerLink]="['/aboutFonts']" routerLinkActive="active" (click)="backToTop()" (click)="navbtnR()">关于字体</a>
                </li>
                <li>
                    <a [routerLink]="['/process']" routerLinkActive="active" (click)="backToTop()" (click)="navbtnR()">研发过程</a>
                </li>
                <li>
                    <a [routerLink]="['/characteristic']" routerLinkActive="active" (click)="backToTop()" (click)="navbtnR()">特点</a>
                </li>
                <li>
                    <a [routerLink]="['/authorize']" routerLinkActive="active" (click)="backToTop()" (click)="navbtnR()">授权</a>
                </li>
                <li>
                    <a [routerLink]="['/Download']" routerLinkActive="active" (click)="backToTop()" (click)="navbtnR()">下载</a>
                </li>
                <li>
                    <a [routerLink]="['/usageMethod']" routerLinkActive="active" (click)="backToTop()" (click)="navbtnR()">使用方法</a>
                </li>
                <li>
                    <a [routerLink]="['/cooperation']" routerLinkActive="active" (click)="backToTop()" (click)="navbtnR()">合作</a>
                </li>
            </ul>
        </div>
    </div>
</div>